<template>
  <div class="container d-flex align-items-center min-vh-100">
    <b-row class="w-100">
      <div class="col-sm-4 offset-sm-2 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="294.194" height="262.907" viewBox="0 0 294.194 262.907">
          <g id="_404" data-name="404" transform="translate(-103.903 -64.106)">
            <g id="_404-2" data-name="404">
              <path id="Path_29" data-name="Path 29" d="M398.1,321.226c0,6.6-65.857,5.752-147.1,5.752s-147.1.843-147.1-5.752,65.858-11.944,147.1-11.944S398.1,314.629,398.1,321.226Z" fill="#231f20" opacity="0.1"/>
              <g id="Group_62" data-name="Group 62">
                <g id="Group_47" data-name="Group 47">
                  <g id="Group_36" data-name="Group 36">
                    <path id="Path_30" data-name="Path 30" d="M302.668,158.87a53.536,53.536,0,1,1-53.535-53.536A53.534,53.534,0,0,1,302.668,158.87Z" fill="#e2e2e2"/>
                    <g id="Group_35" data-name="Group 35">
                      <path id="Path_31" data-name="Path 31" d="M284.728,114.854a50.749,50.749,0,1,1-50.75-50.748A50.748,50.748,0,0,1,284.728,114.854Z" fill="#e2e2e2"/>
                      <path id="Path_32" data-name="Path 32" d="M313.573,111.573A28.054,28.054,0,1,1,285.518,83.52,28.054,28.054,0,0,1,313.573,111.573Z" fill="#e2e2e2"/>
                      <path id="Path_33" data-name="Path 33" d="M266.9,151.648a51.786,51.786,0,1,1-51.787-51.785A51.785,51.785,0,0,1,266.9,151.648Z" fill="#e2e2e2"/>
                      <path id="Path_34" data-name="Path 34" d="M340.567,155.442a47.8,47.8,0,1,1-47.8-47.8A47.8,47.8,0,0,1,340.567,155.442Z" fill="#e2e2e2"/>
                    </g>
                  </g>
                  <g id="Group_46" data-name="Group 46">
                    <g id="Group_37" data-name="Group 37" opacity="0.2">
                      <path id="Path_35" data-name="Path 35" d="M276.222,98.2l.028-.014H212.014v100.32l93.455.452L293.709,115.8Z" fill="#231f20"/>
                    </g>
                    <g id="Group_38" data-name="Group 38">
                      <path id="Path_36" data-name="Path 36" d="M272.654,97l.027-.013H208.447v100.32H291.8V116.144Z" fill="#f1f2f2"/>
                    </g>
                    <g id="Group_39" data-name="Group 39">
                      <rect id="Rectangle_19" data-name="Rectangle 19" width="63.673" height="1.096" transform="translate(213.248 104.721)" fill="#e6e7e8"/>
                      <rect id="Rectangle_20" data-name="Rectangle 20" width="73.996" height="1.096" transform="translate(213.248 114.587)" fill="#e6e7e8"/>
                      <rect id="Rectangle_21" data-name="Rectangle 21" width="73.996" height="1.096" transform="translate(213.248 124.453)" fill="#e6e7e8"/>
                      <rect id="Rectangle_22" data-name="Rectangle 22" width="73.996" height="1.096" transform="translate(213.248 134.319)" fill="#e6e7e8"/>
                      <rect id="Rectangle_23" data-name="Rectangle 23" width="73.996" height="1.096" transform="translate(213.248 144.185)" fill="#e6e7e8"/>
                      <rect id="Rectangle_24" data-name="Rectangle 24" width="73.996" height="1.096" transform="translate(213.248 154.051)" fill="#e6e7e8"/>
                      <rect id="Rectangle_25" data-name="Rectangle 25" width="73.996" height="1.096" transform="translate(213.248 163.917)" fill="#e6e7e8"/>
                      <rect id="Rectangle_26" data-name="Rectangle 26" width="73.996" height="1.096" transform="translate(213.248 173.784)" fill="#e6e7e8"/>
                      <rect id="Rectangle_27" data-name="Rectangle 27" width="73.996" height="1.097" transform="translate(213.248 183.65)" fill="#e6e7e8"/>
                      <rect id="Rectangle_28" data-name="Rectangle 28" width="73.996" height="1.097" transform="translate(213.248 193.515)" fill="#e6e7e8"/>
                    </g>
                    <path id="Path_37" data-name="Path 37" d="M291.806,116.152H272.654V97Z" fill="#fff"/>
                    <g id="Group_45" data-name="Group 45">
                      <g id="Group_42" data-name="Group 42">
                        <g id="Group_40" data-name="Group 40">
                          <path id="Path_38" data-name="Path 38" d="M243.429,132.628A11.726,11.726,0,1,1,231.7,120.9,11.725,11.725,0,0,1,243.429,132.628Z" fill="#fff"/>
                          <path id="Path_39" data-name="Path 39" d="M240.4,132.628a8.693,8.693,0,1,1-8.693-8.694A8.693,8.693,0,0,1,240.4,132.628Z" fill="#414042"/>
                          <path id="Path_40" data-name="Path 40" d="M232.04,126.63a2.965,2.965,0,1,1-2.964-2.965A2.965,2.965,0,0,1,232.04,126.63Z" fill="#fff"/>
                          <path id="Path_41" data-name="Path 41" d="M227.574,132.82a1.473,1.473,0,1,1-1.472-1.472A1.474,1.474,0,0,1,227.574,132.82Z" fill="#fff"/>
                          <path id="Path_42" data-name="Path 42" d="M231.6,136.814a2.248,2.248,0,1,1-2.248-2.248A2.248,2.248,0,0,1,231.6,136.814Z" fill="#fff"/>
                          <path id="Path_43" data-name="Path 43" d="M239.208,134.042c-2.6.4-2.923.731-3.326,3.327-.4-2.6-.73-2.923-3.326-3.327,2.6-.4,2.922-.729,3.326-3.325C236.285,133.313,236.611,133.64,239.208,134.042Z" fill="#fff"/>
                        </g>
                        <g id="Group_41" data-name="Group 41">
                          <path id="Path_44" data-name="Path 44" d="M281.062,132.628A11.726,11.726,0,1,1,269.337,120.9,11.726,11.726,0,0,1,281.062,132.628Z" fill="#fff"/>
                          <path id="Path_45" data-name="Path 45" d="M278.029,132.628a8.692,8.692,0,1,1-8.692-8.694A8.692,8.692,0,0,1,278.029,132.628Z" fill="#414042"/>
                          <path id="Path_46" data-name="Path 46" d="M269.673,126.63a2.965,2.965,0,1,1-2.964-2.965A2.965,2.965,0,0,1,269.673,126.63Z" fill="#fff"/>
                          <path id="Path_47" data-name="Path 47" d="M265.207,132.82a1.473,1.473,0,1,1-1.473-1.472A1.473,1.473,0,0,1,265.207,132.82Z" fill="#fff"/>
                          <path id="Path_48" data-name="Path 48" d="M269.24,136.814a2.249,2.249,0,1,1-2.25-2.248A2.25,2.25,0,0,1,269.24,136.814Z" fill="#fff"/>
                          <path id="Path_49" data-name="Path 49" d="M276.842,134.042c-2.6.4-2.924.731-3.326,3.327-.4-2.6-.731-2.923-3.327-3.327,2.6-.4,2.923-.729,3.327-3.325C273.918,133.313,274.245,133.64,276.842,134.042Z" fill="#fff"/>
                        </g>
                      </g>
                      <g id="Group_44" data-name="Group 44">
                        <g id="Group_43" data-name="Group 43">
                          <path id="Path_50" data-name="Path 50" d="M265.868,166.091a1.746,1.746,0,0,1-1.747-1.747,13.6,13.6,0,0,0-27.2,0,1.747,1.747,0,0,1-3.495,0,17.095,17.095,0,1,1,34.19,0A1.746,1.746,0,0,1,265.868,166.091Z" fill="#414042"/>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_61" data-name="Group 61">
                  <g id="Group_56" data-name="Group 56">
                    <g id="Group_48" data-name="Group 48">
                      <path id="Path_51" data-name="Path 51" d="M348.286,320.424H151.81l.011-151.417H348.278Z" fill="#dfb485"/>
                    </g>
                    <g id="Group_55" data-name="Group 55">
                      <g id="Group_49" data-name="Group 49" opacity="0.1">
                        <rect id="Rectangle_29" data-name="Rectangle 29" width="19.959" height="10.947" transform="translate(151.92 232.361)" fill="#fff"/>
                      </g>
                      <g id="Group_50" data-name="Group 50" opacity="0.1">
                        <rect id="Rectangle_30" data-name="Rectangle 30" width="19.959" height="10.948" transform="translate(151.92 257.858)" fill="#fff"/>
                      </g>
                      <g id="Group_51" data-name="Group 51" opacity="0.1">
                        <rect id="Rectangle_31" data-name="Rectangle 31" width="19.959" height="10.947" transform="translate(151.92 283.357)" fill="#fff"/>
                      </g>
                      <g id="Group_52" data-name="Group 52" opacity="0.1">
                        <rect id="Rectangle_32" data-name="Rectangle 32" width="19.958" height="10.947" transform="translate(328.291 232.361)" fill="#fff"/>
                      </g>
                      <g id="Group_53" data-name="Group 53" opacity="0.1">
                        <rect id="Rectangle_33" data-name="Rectangle 33" width="19.958" height="10.948" transform="translate(328.291 257.858)" fill="#fff"/>
                      </g>
                      <g id="Group_54" data-name="Group 54" opacity="0.1">
                        <rect id="Rectangle_34" data-name="Rectangle 34" width="19.958" height="10.947" transform="translate(328.291 283.357)" fill="#fff"/>
                      </g>
                    </g>
                  </g>
                  <g id="Group_60" data-name="Group 60">
                    <g id="Group_57" data-name="Group 57">
                      <path id="Path_52" data-name="Path 52" d="M386.286,209.51l-40.415-37.958,2.407-2.545,40.4,37.955Z" fill="#efcda9"/>
                    </g>
                    <g id="Group_58" data-name="Group 58">
                      <path id="Path_53" data-name="Path 53" d="M113.82,209.51l40.415-37.958-2.414-2.545-40.394,37.955Z" fill="#efcda9"/>
                    </g>
                    <g id="Group_59" data-name="Group 59">
                      <path id="Path_54" data-name="Path 54" d="M361.394,219.35H138.7l13.118-50.342H348.278Z" fill="#efcda9"/>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Group_64" data-name="Group 64">
              <text id="_404-3" data-name="404" transform="translate(184.142 277.534)" fill="#fff" font-size="64.143" font-family="Montserrat-Black, Montserrat" font-weight="800"><tspan x="0" y="0">404</tspan></text>
              <text id="PAGE_NOT_FOUND" data-name="PAGE NOT FOUND" transform="translate(190.268 298.81)" fill="#fff" font-size="13.472" font-family="Montserrat-Light, Montserrat" font-weight="300"><tspan x="0" y="0">PAGE NOT FOUND</tspan></text>
            </g>
          </g>
        </svg>
      </div>
      <b-col md="6">
        <div class="w-100">
        <div class="clearfix errorText">
          <h1 class="pt-3">Oops! You're lost.</h1>
          <p class="text-muted">The page you are looking for was not found.</p>
          <router-link to="/" class="btn btn-primary backHomeBtn">Back to Home</router-link>
        </div>
        <!-- <CInput
          class="mb-3"
          placeholder="What are you looking for?"
        >
          <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
          <template #append>
            <CButton color="info">Search</CButton>
          </template>
        </CInput> -->
      </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
